import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationRoutes from '../../../Layouts/NavigationRoutes';
import chartIconSvg from '../../Assets/Icons/noSavedCharts.svg';
import LinkButton, { LinkButtonType } from '../../Components/Form/Buttons/LinkButton';
import PageHeader from '../../Components/Headers/PageHeader';
import useLanguage from '../../Services/Language/useLanguageHook';
import styles from './ChartBuilder.module.scss';

const ChartBuilderFirstChartPage: React.FC = () => {
    // Application hooks.
    const [translations] = useLanguage();
    const navigate = useNavigate();

    const navigateToCreateChartPage = () => navigate(NavigationRoutes.ChartBuilder);

    return (
        <div className={styles.chart_builder_landing_container}>
            <div className={styles.chart_builder_landing_inner_container}>
                <img src={chartIconSvg} alt="" />
                <PageHeader title={translations.page.chartBuilder} />
                <p>{translations.chartBuilder.text.createYourOwnChart}</p>
                <LinkButton
                    title={translations.chartBuilder.text.createChart}
                    onClick={navigateToCreateChartPage}
                    type={LinkButtonType.Blue}
                    track={{ eventCategory: 'ChartBuilder', eventAction: 'CreateChartClicked' }}
                />
            </div>
        </div>
    );
};

export default ChartBuilderFirstChartPage;
